module.exports = __webpack_public_path__ + "media/src/fonts/LoraBold-7544785532e4c43829971fa0ade4cb9d.woff";